import { Button, Stack } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IUserContentReviewListFilterFormBodyProps } from '~/components/forms/UserContentReviewListFilterForm';
import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCrowdSearchFiltersRequestBody } from '~/lib/api/modules/Crowd';
import { UserContentReviewListFilterFormBody } from '~/components/forms/UserContentReviewListFilterForm';
import { Aside } from '~/components/molecules/Aside';

export type IUserContentReviewListAsideProps = IContainerProps &
  IUserContentReviewListFilterFormBodyProps & {
    children?: React.ReactNode;
    loading?: boolean;
    onReset?: () => void;
    filter?: IApiCrowdSearchFiltersRequestBody;
  };

export const UserContentReviewListAside: React.FC<
  IUserContentReviewListAsideProps
> = (props) => {
  const { sx, form, children, loading, onReset, ...other } = props;
  const { t } = useTranslation();

  return (
    <Aside sx={sx} headline={t('common.filters')}>
      <UserContentReviewListFilterFormBody form={form} {...other}>
        <Stack horizontal gap={2}>
          <Button type="submit" loading={loading}>
            {t('common.search')}
          </Button>

          {onReset && (
            <Button
              type="reset"
              variant="text"
              disabled={loading}
              onClick={onReset}
            >
              {t('common.reset')}
            </Button>
          )}
        </Stack>
      </UserContentReviewListFilterFormBody>

      {children}
    </Aside>
  );
};
